import React, { useEffect } from 'react';
import CandidateManagementHeader from '../components/CandidateManagementHeader';
import CandidateProfileTable from '../components/shared_components/CandidateProfileTable';
import { useDispatch, useSelector } from 'react-redux';
import InterviewManagementTable from '../components/shared_components/InterviewManagementTable';
import JobDescriptionModal from '../components/common/JobDescriptionModal';
import DecisionCenter from '../components/shared_components/DecisionCenter';
import FilterDropDown from '../components/shared_components/FilterDropDown';
import {
  removeAllActiveFilter,
  updateSearchQuery,
} from '../store/slices/filterOptionsSlice';
import { useLocation } from 'react-router-dom';

function CandidateManagement() {
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  const jobDescModelState = useSelector(
    (state) => state.candidateManagementSlice.isJdModelOpen,
  );
  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();

  const tabKey = `${activeTab}__${activeSubTab}`;
  useEffect(() => {
    // Only clear filters if NOT navigating from Dashboard with a specific job filter
    const returnedFromEvaluation = sessionStorage.getItem(
      'returnedFromEvaluation',
    );
    if (returnedFromEvaluation) {
      sessionStorage.removeItem('returnedFromEvaluation');
      return;
    }

    if (!location.state?.fromDashboard) {
      dispatch(removeAllActiveFilter());
      dispatch(updateSearchQuery(''));
    }
  }, [tabKey]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <div className="relative min-h-screen w-full rounded-2xl border-gray-700/50 dark:glass-effect dark:text-white bg-bgSecondary text-textPrimary px-8 transition-colors flex flex-col">
        <CandidateManagementHeader />
        <div className="w-full min-h-80 flex flex-row ">
          {activeTab === 'SOURCED' && <CandidateProfileTable />}
          {activeTab === 'INTERVIEW' && <InterviewManagementTable />}
          {activeTab === 'DECISION' && <DecisionCenter />}
          {jobDescModelState && <JobDescriptionModal />}
        </div>
      </div>
      {/* {showFilterDropdown && <FilterDropDown/>} */}
    </>
  );
}

export default CandidateManagement;
